<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2020
  -->

<template>
	<div class="h-vh-100 program-template-details-root w-100 hide-scrollbar relative">

		<div v-if="programItem" class="h-100">


			<div class="row h-100">
				<div class="col col-md-8 overflow-y h-100" style="padding-top: 20px;">
					<BackHeader @click="goBack()">
						{{ programItem ? programItem.name : "Loading..." }} <i
						@click.stop="onProgramEditClicked()" class="fontello icon-pencil ml-1 edit"></i>
					</BackHeader>

<!--					<h6>{{ programItem.programTypeFormatted() }} program template</h6>-->

					<el-card class="mb-4">

						<ProgramAgenda
							ref="programAgenda"
							:data="programItem"
							:hide-add-coaching-session="true"
							@change="onProgramChangedWithNotification"
							@changeSilent="onProgramChanged"
							@onItemClicked="onProgramItemClicked"
							@onSectionClicked="onSectionClicked"
							@onSectionDeleteClicked="onSectionDeleteClicked"
							@addTaskClicked="addProgramTaskClicked"
							@addCallClicked="addCallClicked"
							@addSectionClicked="addSectionClicked"
							@addSectionWithSessionClicked="addSectionWithSessionClicked"
							@onAddContractClicked="onAddContractClicked"
							@addNoteClicked="addNoteClicked"
						/>
					</el-card>
				</div>
				<div class="col col-md-4 overflow-y h-100 right-column-main">

					<el-card class="mb-4 program-invite-panel-card">
						<ProgramInvitePanel
							:programItem="programItem"
							:requireSetupItems="requireSetupItems"
							:analytics-props="analyticsPropsMethod()"/>
					</el-card>

					<el-card class="mb-4">
						<CoachingSessionsPanel
							ref="coachingSessions"
							v-bind="$attrs"
							mainRouteName="ProgramTemplateEventType"
							backRouteName="ProgramTemplateDetailsCoach"
							:programItem="programItem"
							v-model="sessionType"
							:showCompletedSessions="false"
							:analytics-props="analyticsPropsMethod()"/>
					</el-card>



					<el-card class="mb-4">
						<ProgramBillingPanel
							ref="programBillingPanel"
							:data="billingData"
							:programItem="programItem"
							:disableInvoices="true"
							:analytics-props="analyticsPropsMethod()"
							@change="onBillingDataChanged"/>
					</el-card>

					<el-card class="mb-4">
						<ClientAccessSettingsPanel
							class="mb-2"
							v-model="programItem.clientAccessSettings"
							:analytics-props="analyticsPropsMethod()"
							@change="onClientEditingSettingsChanged"/>
					</el-card>


				</div>

			</div>

		</div>
		<LoadingIndicator/>
	</div>
</template>

<script>

import {ViewModeEnum} from "@/utils/helpers";
import BaseProgramDetails from "@/core/modules/coach/Coaching/BaseProgramDetails.vue"


import ProgramAgenda from '@/core/components/ProgramAgenda/ProgramAgenda.vue'


import BillingData from "@shared/Billing/BillingData";
import ClientAccessSettingsPanel from "@/core/modules/coach/Coaching/Panels/ClientAccessSettingsPanel.vue";
import CoachingSessionsPanel from "@/core/modules/coach/Coaching/Panels/CoachingSessionsPanel/CoachingSessionsPanel.vue";
import BackHeader from "@/core/components/BackHeader.vue";
import ProgramInvitePanel from "@/core/modules/coach/Coaching/Panels/ProgramInvite/ProgramInvitePanel.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import ProgramBillingPanel from "@/core/modules/coach/Coaching/Panels/ProgramBilling/ProgramBillingPanel.vue";
import SetupItem from "@/core/modules/coach/Coaching/Panels/SetupItem";


export default {
	name: 'Cards',
	extends: BaseProgramDetails,
	components: {
		ProgramBillingPanel,
		LoadingIndicator,
		ProgramInvitePanel,
		BackHeader,
		CoachingSessionsPanel,
		ClientAccessSettingsPanel,
		ProgramAgenda
	},

	watch:{
		sessionType(){
			console.log("sessionType changed = ", this.sessionType)
			this.refreshRequireSetupItems()
		}

	},

	data() {
		return {
			programItem: null,
			sessionType: null,
			brandingSettingsItem: null,
			invoices: [],
			billingData: new BillingData(),
			requireSetupItems: [],
		}
	},



	methods: {

		async loadData() {
			console.log("created this")

			let programItem = await this.$dataManager.getProgram(this.programId)

			if(!programItem){
				return this.goBack()
			}

			let [billingData] = await Promise.all([
				this.$dataManager.getBillingDataByProgramId(this.programId),
			])

			console.log("programItem = ", programItem)

			this.billingData = billingData || programItem.createBillingData()
			this.brandingSettingsItem = this.userProfile.brandingSettings //may be null

			this.programItem = programItem
			await this.ensureInvitationLink()

			if (this.programItem.sessionTypeId) {
				this.sessionType = await this.$dataManager.apiGetEventType({sessionTypeId: this.programItem.sessionTypeId, coachId: this.getCoachId()})
			}

			this.refreshRequireSetupItems()
			this.showItemDetailsIfNeeded();

		},

		refreshRequireSetupItems(){
			let requireSetupItems = []
			if(!this.sessionType){
				requireSetupItems.push(new SetupItem('Select session type below'))
			}
			if(!this.userProfile.schedulerSettings.isSetupCompleted){
				let schedulerSetupLink = this.resolveRelative({name: "SchedulerMain"})
				requireSetupItems.push(new SetupItem('Connect your calendar (from scheduler)', schedulerSetupLink))
			}

			this.requireSetupItems = requireSetupItems
		},


		async ensureInvitationLink(){
			if(!this.programItem.inviteId){
				let programInvite = await this.$dataManager.getProgramInviteByProgramId(this.programItem.id)
				if(!programInvite){
					programInvite = this.programItem.createProgramInvite()
					await this.$dataManager.createProgramInvite(programInvite)
				}
				this.programItem.inviteId = programInvite.id
				this.programItem.isLinkInviteEnabled = true
				await this.$dataManager.updateProgram(this.programItem)
			}
		},

		goBack(){
			let _ = this.$analyticManager.trackEvent("Program template back clicked", this.getProgramAnalyticsData())
			this.go('CoachingTemplatesMainCoach')
		},


		onProgramDeleted() {
			this.go('CoachingMainCoach', {category: 'templates'})
		},


		// addSectionClicked() {
		// 	this.createSectionDialogFn(ViewModeEnum.ADD)
		// 		.then(data => this.createProgramSection(data))
		// 		.catch(error => {
		// 			console.log("createTaskDialog error: ", error)
		// 		})
		// },
		addCallClicked(sectionIndex) {
			this.createCallDialogFn(ViewModeEnum.ADD, undefined, sectionIndex)
				.then(data => this.createProgramStep(data, sectionIndex))
				.catch(error => {
					console.log("createTaskDialog error: ", error)
				})
		},
		addProgramTaskClicked(sectionIndex) {
			this.createTaskDialogFn(ViewModeEnum.ADD)
				.then(data => this.createProgramStep(data, sectionIndex))
				.catch(error => {
					console.log("createTaskDialog error: ", error)
				})
		},

		createProgramStep(programStep, sectionIndex) {
			if(programStep){
				this.programItem.addProgramStep(programStep, sectionIndex)
				return this.onProgramChanged(this.programItem);
			}
		},

	},

	computed: {

	},


}
</script>


<style lang="scss">
.program-template-details-root {
	margin-top: -20px;

	.label-width {
		width: 140px !important;
	}

	.main-content {
		height: calc(100% - 54px);
	}

	.right-column-main {
		padding-top: 62px;
	}

	.card-no-padding {
		.el-card__body {
			padding: 0px;
		}
	}

	.program-invite-panel-card{
		//border: 1px solid #5A9CF8;
		//box-shadow: 0 2px 12px 0 rgba(0, 16, 98,.35);
		box-shadow: 0 2px 12px 0 rgba(0, 16, 98,.5);
	}
}

</style>



